export const inventory_list_table_header = [
	{ order: 1, key: "View Bids", name: "View Bids", visibility: true },
	{ order: 1, key: "Total Bids", name: "Total Bids", visibility: true },
	{ order: 1, key: "YOM", name: "YOM", visibility: true },
	{ order: 2, key: "MAKE", name: "MAKE", visibility: true },
	{ order: 3, key: "STATE", name: "STATE", visibility: true },
	{ order: 4, key: "REG NO.", name: "REG NO.", visibility: true },
	{ order: 5, key: "LOCATION", name: "LOCATION", visibility: true },
	{ order: 6, key: "REPO DATE", name: "REPO DATE", visibility: true },
	{ order: 7, key: "ENGINE NO.", name: "ENGINE NO.", visibility: true },
	{ order: 8, key: "CHASSIS NO.", name: "CHASSIS NO.", visibility: true },
	{ order: 9, key: "MODEL system", name: "MODEL system", visibility: true },
	{ order: 10, key: "CUSTOMER NAME", name: "CUSTOMER NAME", visibility: true },
	{ order: 11, key: "TYPE OF ASSET", name: "TYPE OF ASSET", visibility: true },
	{
		order: 12,
		key: "KOTAK Agmt. No",
		name: "KOTAK Agmt. No",
		visibility: true,
	},
	{
		order: 13,
		key: "PARKING YARD NAME",
		name: "PARKING YARD NAME",
		visibility: true,
	},
	{
		order: 14,
		key: "ADDRESS OF PARKING ADDRESS",
		name: "ADDRESS OF PARKING ADDRESS",
		visibility: true,
	},
	{
		order: 15,
		key: "RC COPY AVAILABLE ( YES / NO)",
		name: "RC COPY AVAILABLE ( YES / NO)",
		visibility: true,
	},
	{
		order: 16,
		key: "Parking Charges Per day Without GST",
		name: "Parking Charges Per day Without GST",
		visibility: true,
	},
	{
		order: 17,
		key: "Link of Vehicle Pictures(Only vehicle pictures)",
		name: "Link of Vehicle Pictures(Only vehicle pictures)",
		visibility: true,
	},
	{ order: 18, key: "View Images", name: "View Images", visibility: true },
	{
		order: 19,
		key: "Upload/Replace Images",
		name: "Upload/Replace Images",
		visibility: true,
	},
	{
		order: 20,
		key: "View Thumbnail",
		name: "View Thumbnail",
		visibility: true,
	},
	{
		order: 21,
		key: "Upload/Replace Thumbnail",
		name: "Upload/Replace Thumbnail",
		visibility: true,
	},
	{ order: 22, key: "Base Price", name: "Base Price", visibility: true },
	{ order: 23, key: "Tractor Image", name: "Tractor Image", visibility: false },
	{
		order: 24,
		key: "Drive or Other Link",
		name: "Drive or Other Link",
		visibility: false,
	},
];

export const inv_table_header_arr = [
	"Tractor Image",
	"Drive or Other Link",
	"STATE",
	"LOCATION",
	"KOTAK Agmt. No",
	"CUSTOMER NAME",
	"MAKE",
	"MODEL system",
	"REG NO.",
	"CHASSIS NO.",
	"ENGINE NO.",
	"YOM",
	"REPO DATE",
	"RC COPY AVAILABLE ( YES / NO)",
	"Parking Charges Per day Without GST",
	"PARKING YARD NAME",
	"ADDRESS OF PARKING ADDRESS",
	"Link of Vehicle Pictures(Only vehicle pictures)",
	"TYPE OF ASSET",
	"Base Price",
];

export const dummy_data = [
	{
		name: "shakti",
		age: "20",
	},
	{
		name: "shakti",
		age: "20",
	},
	{
		name: "shakti",
		age: "20",
	},
	{
		name: "shakti",
		age: "20",
	},
	{
		name: "shakti",
		age: "20",
	},
	{
		name: "shakti",
		age: "20",
	},
	{
		name: "shakti",
		age: "20",
	},
	{
		name: "shakti",
		age: "20",
	},
	{
		name: "shakti",
		age: "20",
	},
	{
		name: "shakti",
		age: "20",
	},
];
